import { withInstall } from "@xplus/utils/with-install";
import filterGroup from "./src/filter-group.vue";
export const xFilterGroup = withInstall(filterGroup);
export default xFilterGroup;
export * from "./src/filter-group";
